import React from "react";
// import "./ProgressBar.scss";
import {FlexRow, Text} from "../../styles/Global";
import { useSelector } from "react-redux";

const ProgressBar = ({
  percent = 0,
  size = 100,
  data = {},
  style,
  fontSize,
  fullBG = false,
  barFillColor,
  barBorderColor
}) => {
  const darkMode = useSelector((state) => state.global.darkMode);
  const getColor = (value) => {
    if (value < 34) return "#FF5252"; // red
    if (value < 80) return "#FFC107"; // yellow
    return "#4CAF50"; // green
  };

  const borderColor= darkMode ? `rgba(255,255,255, 0.3)` : `rgba(0,0,0, 0.3)`;
  const barColor = fullBG
    ? `rgba(0,0,0,.15)`
    : darkMode
    ? `rgba(255,255,255, 0.6)`
    : `rgba(0,0,0,.55)`;

  const ProgressFill = () => {
    return (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: -1,
            // opacity: 1,
            width:
              data.hasOwnProperty("progress") && `${data.progress.percent}%`,
            backgroundColor: `${barColor}`,
            borderRadius: 5,
            transition: "width 0.3s ease-in-out",
          }}
        />
    )
  }


  return fullBG ?
  (
    <ProgressFill />
  )
  : (
    <FlexRow align='center' justify='center' style={{width: '100%', marginTop: 3}}>
    <FlexRow
      style={{
        alignSelf: "stretch",
        minHeight: "4px",
        maxHeight: '7px',
        flexWrap: "wrap",
        position: "relative",
        marginTop: 2,
        border:
          data.hasOwnProperty("progress") &&
          data.progress.percent > 0 &&
          `0.5px solid ${borderColor}`,
        borderRadius: 5,
      }}
    >
      {data.hasOwnProperty("progress") && data.progress.percent > 0 && (
        <ProgressFill />
      )}
    </FlexRow>
      <Text size='.7em' style={{marginLeft: 3}}>
        {data.hasOwnProperty("progress") &&
          data.progress.percent > 0 &&
          `${data.progress.percent}%`}
      </Text>

    </FlexRow>
  );
};

export default ProgressBar;
